import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-sans font-semibold border-[3px] border-black shadow-[4px_4px_0px_#000] transition-all focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0px_#000] active:translate-x-[4px] active:translate-y-[4px] active:shadow-none",
  {
    variants: {
      variant: {
        default:
          "bg-[#ffd703] text-black",
        destructive:
          "bg-red-500 text-white",
        outline:
          "bg-[#fef9e7] text-black",
        secondary:
          "bg-[#e056a0] text-white",
        ghost: "border-transparent shadow-none hover:bg-[#ffd703]/30 hover:translate-x-0 hover:translate-y-0 hover:shadow-none",
        link: "border-transparent shadow-none text-[#8b5cf6] underline-offset-4 hover:underline hover:translate-x-0 hover:translate-y-0 hover:shadow-none",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-8 px-3 text-xs",
        lg: "h-12 px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
